import { IconButton } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

export interface ToggleIconButtonProps {
    /**
     * Determines state
     * */
    value?: boolean
    onIcon: React.ReactElement
    offIcon: React.ReactElement

    /**
     * Click handler for both states
     */
    onClick?: () => void

    /**
     * Custom class names
     */
    className?: string
}

const ToggleIconButton: React.FC<ToggleIconButtonProps> = ({
    value = false,
    offIcon: offValue,
    onIcon: onValue,
    onClick,
    className,
}) => {
    return (
        <IconButton
            data-testid="toggle-icon"
            className={clsx('toggleIconButton', className)}
            disableFocusRipple
            onClick={() => onClick?.()}
            size="small"
            aria-label="toggle icon button"
        >
            {value ? onValue : offValue}
        </IconButton>
    )
}

export default ToggleIconButton
